<template>
<div class="chapter">
<div class="inner_page">
<div id="Dedication">
<div class="box">
<p class="ded-title"><b>DEDICATION</b></p>
<p class="ded-center"><b>To Geoff Rixon</b></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_Dedication.vue?6627649a